import React, { useEffect, useState } from 'react';
import { LOCATION_TYPES_CODE } from 'types';
import PropTypes from 'prop-types';
import AppConst from 'appConstants';
import { Checkbox } from 'carbon-components-react';

const { workPlaceLocItems } = AppConst.enquiry;

const getInitialSelectedWorkPlaceLocItems = (
  locationTypes: any,
  locationsInRoad: any = []
) => {
  const items = [...locationsInRoad];
  if (
    Array.isArray(locationTypes) &&
    locationTypes.includes(LOCATION_TYPES_CODE.PRIVATE)
  ) {
    items.push('Private property');
  }
  if (Array.isArray(items) && items.length > 0) {
    return items.map((item: any) => {
      return workPlaceLocItems.find((i: any) => i.value === item);
    });
  }

  return items;
};

const WorkplaceLocationCheckBoxes: React.FC<Props> = ({
  formValues,
  onChange
}) => {
  const [selectedWorkPlace, setSelectedWorkPlace] = useState<any[]>([]);

  useEffect(() => {
    setSelectedWorkPlace(
      getInitialSelectedWorkPlaceLocItems(
        formValues?.locationTypes,
        formValues?.locationsInRoad
      )
    );
  }, [formValues]);

  const onCheckBoxChange = (value: boolean, id: string) => {
    let selectedWorkPlaceCopy = selectedWorkPlace.map((item: any) =>
      Object.assign({}, item)
    );

    if (value) {
      // Add workplace
      const findSelectedWorkPlace = workPlaceLocItems.find(
        (item: any) => item.id === id
      );

      findSelectedWorkPlace &&
        selectedWorkPlaceCopy.push(findSelectedWorkPlace);
    } else {
      // Remove workplace
      selectedWorkPlaceCopy = selectedWorkPlaceCopy.filter(
        (item: any) => item.id !== id
      );
    }

    onChange(selectedWorkPlaceCopy);
    setSelectedWorkPlace(selectedWorkPlaceCopy);
  };

  const constructWorkplaceLocation = () => {
    return workPlaceLocItems.map((item: any) => {
      const selected = selectedWorkPlace.find(
        (selectedWp: any) => selectedWp.id === item.id
      );

      return (
        <div
          className="workplaceLocationCheckbox-item"
          key={`workplace-checkbox-${item.id}`}
        >
          <Checkbox
            checked={!!selected}
            labelText={item.label}
            id={item.id}
            key={`workplace-checkbox-item-${item.id}`}
            onChange={onCheckBoxChange}
          />
        </div>
      );
    });
  };

  return (
    <div className="workplaceLocationCheckbox">
      {constructWorkplaceLocation()}
    </div>
  );
};

const propTypes = {
  formValues: PropTypes.any,
  onChange: PropTypes.func.isRequired
};

type Props = PropTypes.InferProps<typeof propTypes>;

export default React.memo(WorkplaceLocationCheckBoxes);
